import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex justify-center" };
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#6284D6",
        "fill-rule": "nonzero",
        d: "M43.617.563h114.369c11.143 0 20.254 8.885 20.533 20.025l4.117 164.147c.285 11.34-8.678 20.764-20.018 21.048-.171.004-.343.006-.515.006H39.499c-11.343 0-20.54-9.195-20.54-20.54 0-.17.003-.343.007-.514l4.117-164.147C23.363 9.448 32.473.563 43.618.563z"
    }),
    /*#__PURE__*/ _createElementVNode("g", {
        transform: "translate(112.375 46.893)",
        fill: "#00292B",
        "fill-rule": "nonzero"
    }, [
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "2.574",
            cy: "2.574",
            r: "2.574"
        }),
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "33.46",
            cy: "2.574",
            r: "2.574"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#E8F679",
        "fill-rule": "nonzero",
        d: "M47.408 61.876l26.857 1.407-1.407 26.857L46 88.733z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#FFF",
        "fill-opacity": ".4",
        "fill-rule": "nonzero",
        d: "M69.5 89.964a3.362 3.362 0 003.534-3.181l-3.358-.176-.176 3.357z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#9893C0",
        "stroke-width": "1.681",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "square",
        d: "M54.478 71.504l13.429.704m-13.693 4.33l10.071.529"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#67D1E1",
        "fill-rule": "nonzero",
        stroke: "#67D1E1",
        "stroke-width": ".5",
        d: "M30.914 98.859l26.828-1.876 1.876 26.828-26.828 1.876z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#FFF",
        "fill-opacity": ".4",
        "fill-rule": "nonzero",
        d: "M56.264 124.046a3.362 3.362 0 003.12-3.589l-3.354.235.234 3.354z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#9893C0",
        "stroke-width": "1.681",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "square",
        d: "M39.104 107.554l13.414-.938m-13.062 5.967l10.06-.703"
    }),
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#904C6F",
            "fill-rule": "nonzero",
            d: "M215.923 6.751c11.67 0 21.13 9.46 21.13 21.13v31.138a7.043 7.043 0 1014.086 0V27.881c.001-11.67 9.461-21.13 21.131-21.13s21.13 9.46 21.13 21.13v31.838a7.044 7.044 0 1014.086 0V27.881c0-11.67 9.46-21.13 21.13-21.13 11.67 0 21.13 9.46 21.13 21.13v31.138a7.043 7.043 0 1014.086 0V27.881c-.002-11.67 9.458-21.13 21.128-21.13 11.802 0 21.498 9.32 21.965 21.113l2.686 67.854c1.87 47.229-34.902 87.031-82.13 88.9a84.934 84.934 0 01-3.385.067h-47.31c-47.266 0-85.582-38.316-85.582-85.582 0-1.128.022-2.257.067-3.385l2.686-67.854c.467-11.793 10.163-21.113 21.966-21.113z"
        }),
        /*#__PURE__*/ _createElementVNode("g", {
            "fill-rule": "nonzero",
            transform: "translate(190.547 27.729)"
        }, [
            /*#__PURE__*/ _createElementVNode("rect", {
                width: "47.55",
                height: "24.474",
                fill: "#F7F7FF",
                rx: "2.797"
            }),
            /*#__PURE__*/ _createElementVNode("rect", {
                width: "47.55",
                height: "24.474",
                x: "57.34",
                fill: "#F7F7FF",
                rx: "2.797"
            }),
            /*#__PURE__*/ _createElementVNode("rect", {
                width: "47.55",
                height: "24.474",
                x: "114.679",
                fill: "#F7F7FF",
                rx: "2.797"
            }),
            /*#__PURE__*/ _createElementVNode("rect", {
                width: "47.55",
                height: "24.474",
                x: "172.019",
                fill: "#F7F7FF",
                rx: "2.797"
            }),
            /*#__PURE__*/ _createElementVNode("g", { fill: "#DDDBEA" }, [
                /*#__PURE__*/ _createElementVNode("path", { d: "M67.831 4.71a1.749 1.749 0 11.06 3.497 1.749 1.749 0 01-.06-3.497zM71.327 11.703a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495zM66.083 16.948a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495z" })
            ]),
            /*#__PURE__*/ _createElementVNode("g", { fill: "#DDDBEA" }, [
                /*#__PURE__*/ _createElementVNode("path", { d: "M183.21 4.71a1.749 1.749 0 11.06 3.497 1.749 1.749 0 01-.06-3.497zM186.706 11.703a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495zM181.462 16.948a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495z" })
            ]),
            /*#__PURE__*/ _createElementVNode("g", { fill: "#DDDBEA" }, [
                /*#__PURE__*/ _createElementVNode("path", { d: "M8.394 4.71a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495zM14.815 3.742a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495zM6.646 16.947a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495z" })
            ]),
            /*#__PURE__*/ _createElementVNode("g", { fill: "#DDDBEA" }, [
                /*#__PURE__*/ _createElementVNode("path", { d: "M123.773 4.71a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495zM130.194 3.742a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495zM122.025 16.947a1.748 1.748 0 11.062 3.495 1.748 1.748 0 01-.062-3.495z" })
            ])
        ]),
        /*#__PURE__*/ _createElementVNode("path", {
            stroke: "#F7F7FF",
            "stroke-width": "1.748",
            d: "M233.202 90.663a3.497 3.497 0 003.497-3.497c0-1.287-1.166-3.618-3.497-6.992-2.33 3.374-3.496 5.705-3.496 6.992a3.497 3.497 0 003.496 3.497zm-27.97 17.481a3.496 3.496 0 003.496-3.496c0-1.287-1.166-3.618-3.496-6.993-2.331 3.375-3.497 5.706-3.497 6.993a3.497 3.497 0 003.497 3.496z"
        }),
        /*#__PURE__*/ _createElementVNode("g", {
            stroke: "#00292B",
            "stroke-linecap": "round",
            "stroke-width": "4.196"
        }, [
            /*#__PURE__*/ _createElementVNode("path", { d: "M280.054 100.103a4.195 4.195 0 118.391 0h0m25.173 0a4.196 4.196 0 118.391 0h0" }),
            /*#__PURE__*/ _createElementVNode("path", {
                fill: "#00292B",
                "fill-rule": "nonzero",
                "stroke-linejoin": "round",
                d: "M317.814 112.689c0 9.269-7.514 16.783-16.781 16.783-9.268 0-16.784-7.514-16.784-16.783h33.565z"
            })
        ])
    ]),
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#E8F679",
            "fill-rule": "nonzero",
            d: "M106.75 123.048l5.374-1.344c9.981-2.495 20.2 3.115 23.454 12.875a5.31 5.31 0 0010.188-.392l1.69-6.761c3.185-12.739 14.63-21.675 27.76-21.675a29.494 29.494 0 0128.392 21.507l2.045 7.273a5.161 5.161 0 009.923.048c2.823-9.679 12.757-15.427 22.555-13.052l6.273 1.52c13.489 3.27 22.285 16.253 20.323 29.993l-9.817 68.719c-5.615 39.3-39.273 68.492-78.972 68.492-39.7 0-73.358-29.192-78.973-68.492l-9.915-69.412c-1.91-13.372 6.597-26.023 19.701-29.3z"
        }),
        /*#__PURE__*/ _createElementVNode("g", { transform: "translate(178.82 163.407)" }, [
            /*#__PURE__*/ _createElementVNode("path", {
                stroke: "#00292B",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "4.324",
                d: "M17.25 28.47c3.098 1.028 6.532 1.233 9.921.325a17.209 17.209 0 008.5-5.269"
            }),
            /*#__PURE__*/ _createElementVNode("circle", {
                cx: "2.883",
                cy: "2.883",
                r: "2.883",
                fill: "#00292B",
                "fill-rule": "nonzero"
            }),
            /*#__PURE__*/ _createElementVNode("circle", {
                cx: "37.477",
                cy: "2.883",
                r: "2.883",
                fill: "#00292B",
                "fill-rule": "nonzero"
            })
        ])
    ]),
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#67D1E1",
            "fill-rule": "nonzero",
            stroke: "#67D1E1",
            "stroke-width": ".655",
            d: "M37.173 156.376h36.034c17.058 0 30.886 13.828 30.886 30.886v23.165a7.721 7.721 0 007.722 7.721 9.89 9.89 0 009.594-7.49l.701-2.805a13.593 13.593 0 0113.186-10.295h4.831c8.65 0 15.782 6.783 16.214 15.423l8.446 168.92c.567 11.329-8.159 20.973-19.488 21.54-.342.016-.684.025-1.026.025H24.92c-11.344 0-20.54-9.196-20.54-20.54 0-1 .073-1.999.219-2.988l22.279-151.494h0c-14.215 0-25.739-11.524-25.739-25.739V192.41c0-19.901 16.133-36.034 36.034-36.034z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M84.789 247.746a3.861 3.861 0 017.721 0h0m23.165 0a3.861 3.861 0 017.722 0h0",
            stroke: "#00292B",
            "stroke-linecap": "round",
            "stroke-width": "3.851"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#FF7645",
            "fill-rule": "nonzero",
            stroke: "#FF7645",
            "stroke-width": "1.284",
            d: "M338.657 131.739l-65.054 13.952c-18.338 3.933-31.683 19.787-32.432 38.527l-8.17 204.638c-.453 11.335 8.368 20.89 19.703 21.343.273.011.546.016.82.016h122.065c11.344 0 20.54-9.196 20.54-20.54 0-.243-.005-.487-.013-.731l-7.791-218.503c-.808-22.673-19.845-40.398-42.517-39.59a41.05 41.05 0 00-7.15.888z"
        }),
        /*#__PURE__*/ _createElementVNode("g", { transform: "translate(297.857 183.288)" }, [
            /*#__PURE__*/ _createElementVNode("path", {
                stroke: "#00292B",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "3.851",
                d: "M29.761 20.61c-2.827 3.152-6.93 5.151-11.496 5.151-4.57 0-8.679-1.988-11.507-5.147"
            }),
            /*#__PURE__*/ _createElementVNode("ellipse", {
                cx: "2.898",
                cy: "2.576",
                fill: "#00292B",
                "fill-rule": "nonzero",
                rx: "2.574",
                ry: "2.576"
            }),
            /*#__PURE__*/ _createElementVNode("ellipse", {
                cx: "33.784",
                cy: "2.576",
                fill: "#00292B",
                "fill-rule": "nonzero",
                rx: "2.574",
                ry: "2.576"
            })
        ])
    ]),
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#E8F679",
            "fill-rule": "nonzero",
            d: "M41.714 341.687l26.828-1.876 1.876 26.828-26.828 1.876z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#FFF",
            "fill-opacity": ".4",
            "fill-rule": "nonzero",
            d: "M67.064 366.874a3.362 3.362 0 003.12-3.589l-3.354.235.234 3.354z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            stroke: "#9893C0",
            "stroke-width": "1.681",
            style: { "mix-blend-mode": "multiply" },
            "stroke-linecap": "square",
            d: "M49.904 350.382l13.414-.938m-13.062 5.967l10.06-.703"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#E8F679",
            "fill-rule": "nonzero",
            d: "M340.699 310.148l26.828-1.876 1.876 26.828-26.828 1.876z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#FFF",
            "fill-opacity": ".4",
            "fill-rule": "nonzero",
            d: "M366.05 335.335a3.362 3.362 0 003.119-3.589l-3.354.235.234 3.354z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            stroke: "#9893C0",
            "stroke-width": "1.681",
            style: { "mix-blend-mode": "multiply" },
            "stroke-linecap": "square",
            d: "M348.89 318.843l13.413-.938m-13.062 5.967l10.06-.703"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#67D1E1",
            "fill-rule": "nonzero",
            stroke: "#67D1E1",
            "stroke-width": ".5",
            d: "M317.166 266.31l26.857 1.408-1.407 26.857-26.857-1.407z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#FFF",
            "fill-opacity": ".4",
            "fill-rule": "nonzero",
            d: "M339.258 294.4a3.362 3.362 0 003.534-3.182l-3.358-.176-.176 3.357z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            stroke: "#9893C0",
            "stroke-width": "1.681",
            style: { "mix-blend-mode": "multiply" },
            "stroke-linecap": "square",
            d: "M324.236 275.939l13.429.704m-13.693 4.33l10.071.529"
        }),
        /*#__PURE__*/ _createElementVNode("g", null, [
            /*#__PURE__*/ _createElementVNode("path", {
                fill: "#67D1E1",
                "fill-rule": "nonzero",
                stroke: "#67D1E1",
                "stroke-width": ".5",
                d: "M209.697 334.977l26.828-1.876 1.876 26.828-26.828 1.876z"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                fill: "#FFF",
                "fill-opacity": ".4",
                "fill-rule": "nonzero",
                d: "M235.047 360.164a3.362 3.362 0 003.12-3.589l-3.354.235.234 3.354z"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                stroke: "#9893C0",
                "stroke-width": "1.681",
                style: { "mix-blend-mode": "multiply" },
                "stroke-linecap": "square",
                d: "M217.887 343.672l13.414-.938M218.24 348.7l10.06-.703"
            })
        ]),
        /*#__PURE__*/ _createElementVNode("g", null, [
            /*#__PURE__*/ _createElementVNode("path", {
                fill: "#FFC4C7",
                "fill-rule": "nonzero",
                d: "M200.993 298.246l26.878.939-.939 26.878-26.878-.939z"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                fill: "#FFF",
                "fill-opacity": ".4",
                "fill-rule": "nonzero",
                d: "M223.572 325.945a3.362 3.362 0 003.477-3.242l-3.36-.118-.117 3.36z"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                stroke: "#9893C0",
                "stroke-width": "1.681",
                style: { "mix-blend-mode": "multiply" },
                "stroke-linecap": "square",
                d: "M208.23 307.75l13.439.469m-13.615 4.57l10.079.352"
            })
        ]),
        /*#__PURE__*/ _createElementVNode("g", null, [
            /*#__PURE__*/ _createElementVNode("path", {
                fill: "#FFC4C7",
                "fill-rule": "nonzero",
                d: "M35.97 297.956l26.856 1.407-1.407 26.857-26.857-1.407z"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                fill: "#FFF",
                "fill-opacity": ".4",
                "fill-rule": "nonzero",
                d: "M58.061 326.044a3.362 3.362 0 003.534-3.181l-3.358-.176-.176 3.357z"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                stroke: "#9893C0",
                "stroke-width": "1.681",
                style: { "mix-blend-mode": "multiply" },
                "stroke-linecap": "square",
                d: "M43.039 307.584l13.429.704m-13.693 4.33l10.071.529"
            })
        ]),
        /*#__PURE__*/ _createElementVNode("g", null, [
            /*#__PURE__*/ _createElementVNode("path", {
                fill: "#FFC4C7",
                "fill-rule": "nonzero",
                d: "M350.824 244.42l26.828-1.875 1.876 26.828-26.828 1.876z"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                fill: "#FFF",
                "fill-opacity": ".4",
                "fill-rule": "nonzero",
                d: "M376.174 269.608a3.362 3.362 0 003.12-3.589l-3.354.235.234 3.354z"
            }),
            /*#__PURE__*/ _createElementVNode("path", {
                stroke: "#9893C0",
                "stroke-width": "1.681",
                style: { "mix-blend-mode": "multiply" },
                "stroke-linecap": "square",
                d: "M359.014 253.116l13.414-.938m-13.062 5.967l10.06-.703"
            })
        ])
    ]),
    /*#__PURE__*/ _createElementVNode("g", null, [
        /*#__PURE__*/ _createElementVNode("path", {
            fill: "#FFD220",
            "fill-rule": "nonzero",
            d: "M293.043 325.218l-83.679-83.956c-8.015-8.042-21.031-8.063-29.073-.048-.365.364-.716.74-1.053 1.131l-71.727 83.133c-6.563 7.606-6.667 18.841-.247 26.568l36.346 43.741a41.119 41.119 0 0031.624 14.839h50.768a41.114 41.114 0 0031.262-14.41l36.849-43.131c6.96-8.148 6.495-20.276-1.07-27.866z"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            stroke: "#DDDBEA",
            "stroke-linecap": "round",
            "stroke-width": "3.365",
            d: "M261.013 322.034l-1.362-4.314a3.355 3.355 0 010-2.027l1.042-3.3a3.37 3.37 0 000-2.027l-1.042-3.301a3.355 3.355 0 010-2.027l1.362-4.314h0m-6.729 21.31l-1.363-4.314a3.37 3.37 0 010-2.027l1.363-4.314h0",
            style: { "mix-blend-mode": "multiply" }
        }),
        /*#__PURE__*/ _createElementVNode("g", {
            fill: "#FFF",
            "fill-rule": "nonzero"
        }, [
            /*#__PURE__*/ _createElementVNode("path", {
                stroke: "#FFF",
                "stroke-linejoin": "round",
                "stroke-width": "3.365",
                d: "M247.554 329.324h20.189v26.918h-20.189z"
            }),
            /*#__PURE__*/ _createElementVNode("path", { d: "M270.266 334.371a7.57 7.57 0 000 15.142c4.085 0 5.889-2.98 5.889-7.571 0-4.591-1.804-7.57-5.889-7.57zm0 3.365c1.778 0 2.524 1.233 2.524 4.206 0 2.973-.746 4.206-2.524 4.206a4.206 4.206 0 110-8.412z" })
        ]),
        /*#__PURE__*/ _createElementVNode("g", {
            transform: "matrix(-1 0 0 1 219.5 287.439)",
            fill: "#00292B",
            "fill-rule": "nonzero"
        }, [
            /*#__PURE__*/ _createElementVNode("ellipse", {
                cx: "2.562",
                cy: "2.57",
                rx: "2.562",
                ry: "2.57"
            }),
            /*#__PURE__*/ _createElementVNode("ellipse", {
                cx: "33.304",
                cy: "2.57",
                rx: "2.562",
                ry: "2.57"
            })
        ]),
        /*#__PURE__*/ _createElementVNode("path", {
            stroke: "#FFF",
            "stroke-width": "3.365",
            d: "M223.244 271.126c-10.221 0-18.507 8.286-18.507 18.506 0 10.221 8.286 18.507 18.507 18.507 10.22 0 18.506-8.286 18.506-18.507 0-10.22-8.286-18.506-18.506-18.506zm-43.742 0c-10.221 0-18.507 8.286-18.507 18.506 0 10.221 8.286 18.507 18.507 18.507 10.22 0 18.506-8.286 18.506-18.507 0-10.22-8.286-18.506-18.506-18.506zm24.393 19.347h-5.047"
        })
    ])
], -1);
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { class: "font-semibold max-w-76" };
import ModalDialog from '@/components/ModalDialog.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RemoveMemberModal',
    props: {
        show: { type: Boolean },
        acceptText: null,
        cancelText: null,
        header: null,
        body: null
    },
    emits: ['accept', 'cancel', 'close'],
    setup(__props, { emit }) {
        function handleCancel() {
            emit('cancel');
        }
        function handleAccept() {
            emit('accept');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalDialog, {
                centered: "",
                "dismiss-action": handleCancel,
                "primary-actions": {
                    [__props.acceptText]: handleAccept
                },
                "secondary-actions": { [__props.cancelText]: handleCancel },
                show: __props.show
            }, {
                before: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "411",
                            height: "411",
                            viewBox: "0 0 411 411",
                            class: _normalizeClass('w-36 h-36'),
                            src: '@/assets/images/sign-up.svg',
                            "svg-inline": ''
                        }, _hoisted_4, 8, _hoisted_2))
                    ])
                ]),
                heading: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.header), 1)
                ]),
                after: _withCtx(() => [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(__props.body), 1)
                ]),
                _: 1
            }, 8, ["primary-actions", "secondary-actions", "show"]));
        };
    }
});
